<page-data-manager>
    <div class="flash-message-container">
      <flash-message></flash-message>
    </div>
  
    <div class="row">
      <div class="col-xs-12">
        <div class='page-header'>
          <div ng-if="permissions.safras.canManage" class='btn-toolbar pull-right'>
            <div class='btn-group'>
              <a class="btn btn-primary btn-sm btn-action" href="#!/safras/new" uib-tooltip="Novo Talhão" tooltip-placement="left">
                Novo <i class="fa fa-plus"></i>
              </a>
            </div>
          </div>
          <h2>Safras</h2>
        </div>
      </div>
    </div>
  
    <div class="row">
      <div class="col-xs-12" ng-show="safras">
        <div class="panel panel-default">
          <div class="panel-body">
            <div class="row">
              <div class="col-xs-12">
                <label>Filtrar</label>
              </div>
              <div class="col-xs-3 form-group">
                <select class="form-control" ng-model="filter.status">
                  <option value="all">Todos</option>
                  <option value="active">Apenas ativos</option>
                  <option value="inactive">Apenas inativos</option>
                </select>
              </div>
              <div class="col-xs-2">
                <div class="btn-group">
                  <button type="submit" class="btn btn-success" ng-click="list()">
                    <i class="fa fa-search"></i>
                  </button>
                </div>
              </div>
            </div>
  
            <hr>
  
            <div class="row">
              <div class="col-xs-12">
                <small ng-show="safras.length == 0">Nenhuma safra encontrada!</small>
  
                <table class="table table-hover table-striped" ng-show="safras.length > 0">
                  <thead>
                    <tr>
                      <th class="col-xs-3">Descrição</th>
                      <th class="col-xs-3 text-center">Data Inicial</th>
                      <th class="col-xs-3 text-right">Data Final</th>
                      <th class="col-xs-1"></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr ng-repeat="safra in safras track by $index">
                      <td class="vertical-middle text-left">{{safra.descricao}}</td>
                      <td class="vertical-middle text-center">{{safra.data_inicial | date}}</td>
                      <td class="vertical-middle text-right">{{safra.data_final | date}}</td>
                      <td class="vertical-middle text-right">
                        
                        <div class="btn btn-primary btn-sm" ng-if="permissions.safras.canManage && safra.ativa" ng-click="inactivate(safra.id)" 
                        uib-tooltip="Inativar Safra" tooltip-placement="top">
                          <i class="glyphicon glyphicon-trash"></i>
                        </div>
  
                        <div class="btn btn-primary btn-sm" ng-if="permissions.safras.canManage && !safra.ativa" ng-click="activate(safra.id)" 
                        uib-tooltip="Ativar Safra" tooltip-placement="top">
                          <i class="glyphicon glyphicon-cog"></i>
                        </div>
                        <div class="btn btn-primary btn-sm" ng-if="permissions.safras.canManage" ng-click="edit(safra.id)"  uib-tooltip="Editar">
                          <i class="glyphicon glyphicon-pencil"></i>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page-data-manager>
  